export const checkPhone = (phone: any) => {
  if (phone) {
    const regex = /[a-zA-Z]/;
    if (regex.test(phone)) return false;
    if (/[-[\]{}|;:'".,<>?/()&^%$#@!`~_+=*()]/.test(phone)) return false;
    return true;
  }
};

export function getLocale(): string {
  try {
    const fromI18n = typeof localStorage !== 'undefined' && localStorage.getItem('i18nextLng');
    if (fromI18n) return fromI18n;
  } catch { }
  if (typeof document !== 'undefined') {
    const fromDom = document.documentElement.getAttribute('lang');
    if (fromDom) return fromDom;
  }
  return 'en';
}